import { Pipe, PipeTransform } from '@angular/core';
import { LookupResType } from '../../enums/lookup-expr.enum';

@Pipe({
  name: 'radioTemplateClass',
  standalone: true,
})
export class RadioTemplateClassPipe implements PipeTransform {
  transform(value: string, items: LookupResType[]): string {
    if (!value || !items) return '';
    
    const selectedItem = items.find(item => item.ozelKod === value);
    return selectedItem ? selectedItem.aciklama.toLowerCase() : '';
  }
}


